import { render, staticRenderFns } from "./BulletPoints.vue?vue&type=template&id=63a474f0&scoped=true"
import script from "./BulletPoints.vue?vue&type=script&lang=js"
export * from "./BulletPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a474f0",
  null
  
)

export default component.exports